import { Copy } from "lucide-react"
import * as React from "react"
import { useCopyToClipboard } from "../hooks/useCopyToClipboard"
import { cn } from "../utils"

export interface EmailProps extends React.HTMLAttributes<HTMLDivElement> {
  email?: string | null
  showCopy?: boolean
  showLink?: boolean
  copyMessage?: string
  errorMessage?: string
}

function Email({
  className,
  email,
  showCopy = false,
  showLink = false,
  copyMessage,
  errorMessage,
  ...props
}: EmailProps) {
  const { isCopied, onCopy } = useCopyToClipboard({
    text: email || "",
    copyMessage,
    errorMessage,
  })

  const content = (
    <>
      <span>{email || "-"}</span>
      {showCopy && (
        <button
          onClick={onCopy}
          className={cn(
            "opacity-0 group-hover:opacity-100 transition-opacity",
            "flex items-center justify-center w-5 h-5 rounded",
            "hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1",
            isCopied && "opacity-100 text-green-600",
          )}
          title={isCopied ? "Copied!" : "Copy email"}
        >
          <Copy className="h-3 w-3" />
        </button>
      )}
    </>
  )

  if (showLink && email) {
    const { ...anchorProps } = props as React.HTMLAttributes<HTMLAnchorElement>
    return (
      <a
        href={`mailto:${email}`}
        className={cn(
          "group flex items-center gap-2 text-sm transition-colors hover:text-primary hover:underline w-fit",
          className,
        )}
        {...anchorProps}
      >
        {content}
      </a>
    )
  }

  return (
    <div
      className={cn("group flex items-center gap-2 text-sm transition-colors w-fit", className)}
      {...props}
    >
      {content}
    </div>
  )
}

export { Email }
